// ============================================================
// CATALOGO UNIVERSITÀ — dati verificati dalle fonti ufficiali
// eCampus: https://www.uniecampus.it/didattica/corsi-di-laurea/
// Link:    https://www.unilink.it/didattica/corsi-di-laurea
// Master:  https://www.unilink.it/didattica/master
//          https://www.uniecampus.it/index.php?id=4339 (Mondo Scuola)
// Ultima verifica: 13 ottobre 2026 (offerta lauree 2026/2027)
// ============================================================

export const DATA_VERIFICA_LAUREE = "13 ottobre 2026";
export const DATA_VERIFICA_MASTER = "13 ottobre 2026";

const EC = "eCampus";
const LK = "Università degli Studi Link";

const EC_CDS = "https://uniecampus.coursecatalogue.cineca.it/corsi/2026";
const EC_SUA = "https://www.uniecampus.it/fileadmin/user_upload/Sua_PDF_2026";

const ec = (nome, classe, tipologia, durata, area, cdsId, extra = "") => ({
  nome,
  ateneo: EC,
  classe,
  tipologia,
  durata,
  area,
  modalita: "Full Online",
  accesso: "Libero",
  sedi: [],
  link: `${EC_CDS}/${cdsId}/insegnamenti${extra}`,
  sua: `${EC_SUA}/${classe.replace("/", "")}.pdf`,
});

export const LAUREE = [
  // ---------- eCampus — Triennali ----------
  ec("Design e Discipline della Moda", "L-3", "Triennale", "3 anni", "Arti e design", "11206", "/9999"),
  ec("Ingegneria Civile e Ambientale", "L-7", "Triennale", "3 anni", "Ingegneria e tecnologia", "11209"),
  ec("Ingegneria Informatica e dell'Automazione", "L-8", "Triennale", "3 anni", "Ingegneria e tecnologia", "11210"),
  ec("Ingegneria Industriale", "L-9", "Triennale", "3 anni", "Ingegneria e tecnologia", "11211"),
  ec("Letteratura, Arte, Musica e Spettacolo", "L-10", "Triennale", "3 anni", "Umanistica", "11197"),
  ec("Lingue e Culture Europee e del Resto del Mondo", "L-11", "Triennale", "3 anni", "Lingue", "11198"),
  ec("Scienze Biologiche", "L-13", "Triennale", "3 anni", "Scienze", "11199"),
  ec("Servizi Giuridici", "L-14", "Triennale", "3 anni", "Giuridica", "11200"),
  ec("Scienze del Turismo per il Management e i Beni Culturali", "L-15", "Triennale", "3 anni", "Turismo e beni culturali", "11201"),
  ec("Scienze dell'Educazione e della Formazione", "L-19", "Triennale", "3 anni", "Scienze della formazione", "11202"),
  ec("Scienze della Comunicazione", "L-20", "Triennale", "3 anni", "Comunicazione e DAMS", "11203"),
  ec("Scienze delle Attività Motorie e Sportive", "L-22", "Triennale", "3 anni", "Scienze motorie", "11204"),
  ec("Scienze e Tecniche Psicologiche", "L-24", "Triennale", "3 anni", "Psicologia", "11205"),
  ec("Economia", "L-33", "Triennale", "3 anni", "Economia e management", "11207"),
  ec("Scienze Politiche e Sociali", "L-36", "Triennale", "3 anni", "Politica e sicurezza", "11208"),
  // ---------- eCampus — Magistrali ----------
  ec("Letteratura, Lingua e Cultura Italiana", "LM-14", "Magistrale", "2 anni", "Umanistica", "11212"),
  ec("Ingegneria Civile", "LM-23", "Magistrale", "2 anni", "Ingegneria e tecnologia", "11213"),
  ec("Ingegneria Informatica e dell'Automazione", "LM-32", "Magistrale", "2 anni", "Ingegneria e tecnologia", "11214"),
  ec("Ingegneria Industriale", "LM-33", "Magistrale", "2 anni", "Ingegneria e tecnologia", "11215"),
  ec("Lingue e Letterature Moderne e Traduzione Interculturale", "LM-37", "Magistrale", "2 anni", "Lingue", "11216"),
  ec("Psicologia", "LM-51", "Magistrale", "2 anni", "Psicologia", "11217"),
  ec("Scienze dell'Economia", "LM-56", "Magistrale", "2 anni", "Economia e management", "11218"),
  ec("Scienze della Nutrizione Umana", "LM-61", "Magistrale", "2 anni", "Sanità", "11219"),
  ec("Scienze dell'Esercizio Fisico per il Benessere e la Salute", "LM-67", "Magistrale", "2 anni", "Scienze motorie", "11220"),
  ec("Scienze Pedagogiche", "LM-85", "Magistrale", "2 anni", "Scienze della formazione", "11221"),
  // ---------- eCampus — Ciclo unico ----------
  ec("Giurisprudenza", "LMG/01", "Magistrale a ciclo unico", "5 anni", "Giuridica", "11222", "/9999"),

  // ---------- Link — Triennali ----------
  {
    nome: "DAMS — Produzione audiovisiva e teatrale",
    ateneo: LK, classe: "L-3", tipologia: "Triennale", durata: "3 anni",
    area: "Comunicazione e DAMS", modalita: null, accesso: null, sedi: ["Roma"],
    link: "https://www.unilink.it/didattica/corsi-di-laurea/dams-produzione-audiovisiva-e-teatrale-l-3-aa-26-27",
  },
  {
    nome: "Ingegneria dell'Intelligenza Artificiale",
    ateneo: LK, classe: "L-8", tipologia: "Triennale", durata: "3 anni",
    area: "Ingegneria e tecnologia", modalita: null, accesso: null, sedi: ["Napoli"],
    link: "https://www.unilink.it/cds/ingegneria-dellintelligenza-artificiale-l-8-aa-25-26",
    nota: "Pagina ufficiale riferita all'a.a. 2025/2026; il corso risulta nell'offerta 2026/2027 con piano di studi aggiornato.",
  },
  {
    nome: "Economia e management d'impresa e delle istituzioni",
    ateneo: LK, classe: "L-18", tipologia: "Triennale", durata: "3 anni",
    area: "Economia e management", modalita: null, accesso: null, sedi: ["Roma"],
    link: "https://www.unilink.it/cds/economia-e-management-dimpresa-e-delle-istituzioni-l-18-aa-26-27",
  },
  {
    nome: "Scienze delle comunicazioni, media e tecnologie digitali",
    ateneo: LK, classe: "L-20", tipologia: "Triennale", durata: "3 anni",
    area: "Comunicazione e DAMS", modalita: null, accesso: null, sedi: ["Roma"],
    link: "https://www.unilink.it/cds/scienze-delle-comunicazioni-media-e-tecnologie-digitali-l-20-aa-26-27",
  },
  {
    nome: "Scienze delle attività motorie e sportive",
    ateneo: LK, classe: "L-22", tipologia: "Triennale", durata: "3 anni",
    area: "Scienze motorie", modalita: null, accesso: null, sedi: ["Roma"],
    link: "https://www.unilink.it/cds/scienze-delle-attivita-motorie-e-sportive-l-22-aa-26-27",
  },
  {
    nome: "Scienze e tecniche psicologiche",
    ateneo: LK, classe: "L-24", tipologia: "Triennale", durata: "3 anni",
    area: "Psicologia", modalita: null, accesso: null, sedi: ["Roma"],
    link: "https://www.unilink.it/cds/scienze-e-tecniche-psicologiche-l-24-aa-26-27",
  },
  {
    nome: "Scienze politiche, diplomatiche e governo delle amministrazioni",
    ateneo: LK, classe: "L-36", tipologia: "Triennale", durata: "3 anni",
    area: "Politica e sicurezza", modalita: null, accesso: null, sedi: ["Roma"],
    link: "https://www.unilink.it/didattica/corsi-di-laurea/scienze-politiche-diplomatiche-e-governo-delle-amministrazioni-l-36-aa-26-27",
  },
  {
    nome: "Scienze della difesa e della sicurezza",
    ateneo: LK, classe: "L/DS", tipologia: "Triennale", durata: "3 anni",
    area: "Politica e sicurezza", modalita: null, accesso: null, sedi: ["Roma"],
    link: "https://www.unilink.it/cds/scienze-della-difesa-e-della-sicurezza-lds-aa-26-27",
  },
  {
    nome: "Infermieristica",
    ateneo: LK, classe: "L/SNT1", tipologia: "Triennale", durata: "3 anni",
    area: "Sanità", modalita: "In presenza", accesso: "Con prova di ammissione",
    sedi: ["Roma", "Città di Castello"],
    sedi_prova: "Le selezioni possono prevedere sedi di prova aggiuntive (es. Parigi, Berlino, Madrid): sono sedi della sola prova di ammissione, non del corso.",
    link: "https://www.unilink.it/cds/professioni-sanitarie-aa-26-27/roma/infermieristica-l/snt1",
  },
  {
    nome: "Fisioterapia",
    ateneo: LK, classe: "L/SNT2", tipologia: "Triennale", durata: "3 anni",
    area: "Sanità", modalita: "In presenza", accesso: "Con prova di ammissione",
    sedi: ["Roma", "Città di Castello", "Fano", "Macerata", "Matera", "Napoli", "Pietra Ligure"],
    link: "https://www.unilink.it/cds/professioni-sanitarie-aa-26-27/roma/fisioterapia-l/snt2",
  },
  {
    nome: "Tecniche di laboratorio biomedico",
    ateneo: LK, classe: "L/SNT3", tipologia: "Triennale", durata: "3 anni",
    area: "Sanità", modalita: "In presenza", accesso: "Con prova di ammissione",
    sedi: ["Roma"],
    link: "https://www.unilink.it/cds/professioni-sanitarie-aa-26-27/roma/tecniche-di-laboratorio-biomedico-l/snt3",
  },
  {
    nome: "Tecniche di radiologia medica, per immagini e radioterapia",
    ateneo: LK, classe: "L/SNT3", tipologia: "Triennale", durata: "3 anni",
    area: "Sanità", modalita: "In presenza", accesso: "Con prova di ammissione",
    sedi: ["Roma"],
    link: "https://www.unilink.it/cds/professioni-sanitarie-aa-26-27/roma/tecniche-di-radiologia-medica-per-immagini-e-radioterapia-l/snt3",
  },
  {
    nome: "Osteopatia",
    ateneo: LK, classe: "L/SNT4", tipologia: "Triennale", durata: "3 anni",
    area: "Sanità", modalita: "In presenza", accesso: "Con prova di ammissione",
    sedi: ["Roma", "Città di Castello", "Novedrate"],
    link: "https://www.unilink.it/cds/professioni-sanitarie-aa-26-27/roma/osteopatia-l/snt4",
  },
  // ---------- Link — Magistrali ----------
  {
    nome: "Scienze economiche, del lavoro e dei sistemi socio-sanitari",
    ateneo: LK, classe: "LM-56", tipologia: "Magistrale", durata: "2 anni",
    area: "Economia e management", modalita: null, accesso: null, sedi: ["Roma"],
    link: "https://www.unilink.it/cds/scienze-economiche-del-lavoro-e-dei-sistemi-socio-sanitari-lm-56-aa-25-26",
    nota: "Pagina di dettaglio aggiornata all'a.a. 2025/2026; il corso risulta nell'offerta 2026/2027.",
  },
  {
    nome: "Tecnologie e linguaggi della comunicazione",
    ateneo: LK, classe: "LM-59", tipologia: "Magistrale", durata: "2 anni",
    area: "Comunicazione e DAMS", modalita: null, accesso: null, sedi: ["Roma"],
    link: "https://www.unilink.it/didattica/corsi-di-laurea/tecnologie-e-linguaggi-della-comunicazione-lm-59-aa-26-27",
  },
  {
    nome: "Studi strategici e politiche della sicurezza",
    ateneo: LK, classe: "LM-62", tipologia: "Magistrale", durata: "2 anni",
    area: "Politica e sicurezza", modalita: null, accesso: null, sedi: ["Roma"],
    link: "https://www.unilink.it/cds/studi-strategici-e-politiche-della-sicurezza-lm-62-aa-26-27",
  },
  {
    nome: "Direzione aziendale e della Pubblica Amministrazione — Corporate management and public administration",
    ateneo: LK, classe: "LM-77", tipologia: "Magistrale", durata: "2 anni",
    area: "Economia e management", modalita: null, accesso: null, sedi: ["Roma"],
    link: "https://www.unilink.it/cds/direzione-aziendale-e-della-pubblica-amministrazione-lm-77-aa-25-26",
    nota: "Pagina di dettaglio aggiornata all'a.a. 2025/2026; il corso risulta nell'offerta 2026/2027.",
  },
  // ---------- Link — Ciclo unico ----------
  {
    nome: "Giurisprudenza",
    ateneo: LK, classe: "LMG-01", tipologia: "Magistrale a ciclo unico", durata: "5 anni",
    area: "Giuridica", modalita: null, accesso: null, sedi: ["Roma"],
    link: "https://www.unilink.it/cds/giurisprudenza-lmg-01-aa-26-27",
  },
  {
    nome: "Farmacia",
    ateneo: LK, classe: "LM-13", tipologia: "Magistrale a ciclo unico", durata: "5 anni",
    area: "Sanità", modalita: "In presenza", accesso: null, sedi: ["Roma"],
    link: "https://www.unilink.it/cds/farmacia-lm-13-aa-26-27",
  },
  {
    nome: "Medicina e Chirurgia",
    ateneo: LK, classe: "LM-41", tipologia: "Magistrale a ciclo unico", durata: "6 anni",
    area: "Sanità", modalita: "In presenza", accesso: "Con prova di ammissione",
    sedi: ["Roma", "Novedrate", "Ascoli Piceno", "Fano", "Pescara", "Pietra Ligure", "Matera", "Frosinone"],
    sedi_prova: "Le selezioni possono prevedere sedi di prova aggiuntive (es. Parigi, Berlino, Madrid): sono sedi della sola prova di ammissione, non del corso.",
    link: "https://www.unilink.it/cds/medicina-e-chirurgia-lm-41-aa-26-27-roma",
  },
  {
    nome: "Medicina Veterinaria",
    ateneo: LK, classe: "LM-42", tipologia: "Magistrale a ciclo unico", durata: "5 anni",
    area: "Sanità", modalita: "In presenza", accesso: "Con prova di ammissione", sedi: ["Roma"],
    link: "https://www.unilink.it/cds/veterinaria-lm-42-aa-26-27-roma",
  },
  {
    nome: "Odontoiatria e Protesi Dentaria",
    ateneo: LK, classe: "LM-46", tipologia: "Magistrale a ciclo unico", durata: "6 anni",
    area: "Sanità", modalita: "In presenza", accesso: "Con prova di ammissione",
    sedi: ["Città di Castello", "Macerata", "Roma", "Pescara"],
    sedi_prova: "Le selezioni possono prevedere sedi di prova aggiuntive (es. Parigi, Berlino, Madrid): sono sedi della sola prova di ammissione, non del corso.",
    link: "https://www.unilink.it/cds/odontoiatria-lm-46-aa-26-27-tutte-le-sedi",
  },
  {
    nome: "Scienze della formazione primaria",
    ateneo: LK, classe: "LM-85 bis", tipologia: "Magistrale a ciclo unico", durata: "5 anni",
    area: "Scienze della formazione", modalita: "In presenza", accesso: "Con prova di ammissione",
    sedi: ["Città di Castello", "Roma", "Napoli"],
    link: "https://www.unilink.it/cds/scienze-formazione-primaria-lm-85-bis-aa-26-27-roma",
  },
];

// ============================================================
// MASTER UNIVERSITARI
// Link: requisiti dalla pagina ufficiale master:
//  I livello → laurea triennale; II livello → laurea magistrale/specialistica/vecchio ordinamento
// eCampus (Mondo Scuola): master di I livello online, riconosciuti MUR,
//  durata 12 mesi dall'immatricolazione (da FAQ ufficiali), rivolti a docenti,
//  educatori e professionisti dell'istruzione.
// ============================================================

const EC_MASTER_PAGE = "https://www.uniecampus.it/index.php?id=4339";
const EC_MASTER_PDF = "https://www.uniecampus.it/fileadmin/documenti/area_scuola/ELENCO_PERCORSI_MONDO_SCUOLA.pdf";

const ecMaster = (nome) => ({
  nome: nome.charAt(0) + nome.slice(1).toLowerCase().replace(/\bl2\b/i, "L2").replace(/\bdsga\b/i, "DSGA").replace(/\bdsa\b/i, "DSA").replace(/\bbes\b/i, "BES").replace(/\bclil\b/i, "CLIL"),
  ateneo: EC,
  livello: "I livello",
  edizione: null,
  durata: "12 mesi dall'immatricolazione",
  cfu: null,
  area: "Scienze della formazione",
  modalita: "Online",
  requisiti: "Rivolto a docenti, educatori e professionisti dell'istruzione",
  sedi: [],
  scadenza: null,
  stato: null,
  link: EC_MASTER_PAGE,
  bando: EC_MASTER_PDF,
});

const lkMaster = (nome, livello, edizione, slug, area) => ({
  nome,
  ateneo: LK,
  livello,
  edizione,
  durata: null,
  cfu: null,
  area,
  modalita: null,
  requisiti:
    livello === "I livello"
      ? "Laurea triennale (ammissione tramite prova di selezione)"
      : "Laurea magistrale, specialistica o di vecchio ordinamento (ammissione tramite prova di selezione)",
  sedi: [],
  scadenza: null,
  stato: null,
  link: `https://www.unilink.it/didattica/master/${slug}`,
});

export const MASTER = [
  // ---------- eCampus — Mondo Scuola (I livello, online) ----------
  ...[
    "AUTISMO: DALLA DIAGNOSI ALL'INTERVENTO PSICOEDUCATIVO",
    "L'ABILITAZIONE ALL'INSEGNAMENTO NELLA SCUOLA DELL'INCLUSIONE. IL DOCENTE DELLE COMPETENZE CULTURALI, EDUCATIVE, PEDAGOGICHE, METODOLOGICHE E RELAZIONALI",
    "COMPETENZE E METODOLOGIE DIDATTICHE DELL'ANIMATORE DIGITALE",
    "DIDATTICA E ARTI TERAPIE — TECNICHE CREATIVE IN AMBITO SCOLASTICO",
    "IL BULLISMO: INTERPRETAZIONE, FENOMENOLOGIA, PREVENZIONE E DIDATTICA",
    "NUOVA DIDATTICA PER LE LINGUE: MULTIMEDIALE, FLIPPED LEARNING E CLIL",
    "COMPETENZE NON COGNITIVE E LIFE SKILLS IN AMBITO SCOLASTICO",
    "COMPETENZE PER SVILUPPARE IL PENSIERO COMPUTAZIONALE CON IL CODING",
    "DIDATTICA DELLA LINGUA ITALIANA COME LINGUA SECONDA (L2)",
    "DIDATTICA INTEGRALE PER IL NUOVO AMBIENTE DI APPRENDIMENTO",
    "METODOLOGIE DIDATTICHE PER L'INTEGRAZIONE DEGLI ALUNNI CON DSA",
    "IL DIRIGENTE SCOLASTICO: FUNZIONI, COMPETENZE E RESPONSABILITÀ NEL SISTEMA SCOLASTICO ITALIANO",
    "IL DOCENTE DI SOSTEGNO «DAL VERO»",
    "EDUCARE IN ISTITUTI PENITENZIARI",
    "LE FUNZIONI DEL DIRIGENTE TECNICO TRA VALUTAZIONE E MANAGEMENT",
    "GLOTTODIDATTICA INFANTILE",
    "L'INSEGNAMENTO DELL'ITALIANO AGLI STRANIERI, L2",
    "LA FIGURA DELL'INSEGNANTE DI SOSTEGNO NELLA SCUOLA",
    "MANAGEMENT DELLA SCUOLA: IL DSGA",
    "A SCUOLA OGGI — ALTERNANZA SCUOLA LAVORO",
    "A SCUOLA OGGI — DIDATTICA METACOGNITIVA",
    "A SCUOLA OGGI — METODOLOGIE DIDATTICHE (BES)",
    "LA PROFESSIONE DOCENTE NELLA SCUOLA DI OGGI",
    "PSICOLOGIA SCOLASTICA",
    "PROFILI PEDAGOGICI E DIDATTICI DELL'INSEGNAMENTO DI SCIENZE MOTORIE NELLA SCUOLA PRIMARIA",
    "TECNOLOGIE DIGITALI E METODOLOGIE DIDATTICHE A DISTANZA — FORMAZIONE CONTINUA E NEI CONTESTI",
    "TECNOLOGIE DIGITALI E METODOLOGIE DIDATTICHE A DISTANZA — INSEGNAMENTO DI SOSTEGNO",
    "TECNOLOGIE DIGITALI E METODOLOGIE DIDATTICHE A DISTANZA — SCUOLA DELL'INFANZIA",
    "TECNOLOGIE DIGITALI E METODOLOGIE DIDATTICHE A DISTANZA — SCUOLA PRIMARIA",
    "TECNOLOGIE DIGITALI E METODOLOGIE DIDATTICHE A DISTANZA — SCUOLA SECONDARIA DI I E II GRADO",
    "IL DOCENTE DI SOSTEGNO: EDUCARE ALL'INCLUSIONE",
    "IL PROFILO PROFESSIONALE DEL DOCENTE ABILITATO E LE COMPETENZE CHIAVE",
  ].map(ecMaster),

  // ---------- Link — I livello ----------
  lkMaster("Alta Moda e Lusso", "I livello", "III edizione", "alta-moda-e-lusso-iii-edizione", "Arte, moda e spettacolo"),
  lkMaster("Ambienti immersivi e spazi comunicativi", "I livello", "I edizione", "ambienti-immersivi-e-spazi-comunicativi-i-edizione", "Arte, moda e spettacolo"),
  lkMaster("Assistenza Psichiatrica Avanzata e Salute Mentale", "I livello", "I edizione", "assistenza-psichiatrica-avanzata-e-salute-mentale-i-edizione", "Sanità e benessere"),
  lkMaster("Competenze Osteopatiche in età evolutiva", "I livello", "I edizione", "competenze-osteopatiche-in-eta-evolutiva-i-edizione", "Sanità e benessere"),
  lkMaster("Cyber Incident Response, Threat Intelligence & Forensics", "I livello", "I edizione", "cyber-incident-response-threat-intelligence-forensics-i-edizione", "Tecnologia e innovazione"),
  lkMaster("Master Executive in Cybersecurity", "I livello", "X edizione", "master-in-cybersecurity-x-edizione", "Tecnologia e innovazione"),
  lkMaster("Diritto, Economia ed Innovazione dello Sport", "I livello", "XII edizione", "diritto-economia-ed-innovazione-dello-sport-xii-edizione", "Sport"),
  lkMaster("Fisioterapia nello Sport", "I livello", "II edizione", "fisioterapia-nello-sport-ii-edizione", "Sport"),
  lkMaster("Geopolitica e Geoeconomia delle imprese", "I livello", "I edizione", "geopolitica-e-geoeconomia-delle-imprese-i-edizione", "Economia e management"),
  lkMaster("Governance e Management dei Servizi Sanitari e Funzioni di Coordinamento delle Professioni Sanitarie", "I livello", "I edizione", "governance-e-management-dei-servizi-sanitari-e-funzioni-di-coordinamento-delle-professioni-sanitarie-i-edizione", "Sanità e benessere"),
  lkMaster("Intelligenza Artificiale Applicata per Professionisti: Governance, Innovazione e Responsabilità", "I livello", "I edizione", "intelligenza-artificiale-applicata-per-professionisti-governance-innovazione-e-responsabilita-i-edizione", "Tecnologia e innovazione"),
  lkMaster("Longevità, Epigenetica e Terapie Rigenerative Dermatofunzionali", "I livello", "I edizione", "longevita-epigenetica-e-terapie-rigenerative-dermatofunzionali-i-edizione", "Sanità e benessere"),
  lkMaster("Luxury Management", "I livello", "IX edizione", "luxury-management-ix-edizione", "Economia e management"),
  lkMaster("MBA in Management, Marketing & Finance", "I livello", "II edizione", "mba-in-management-marketing-finance-ii-edizione", "Economia e management"),
  lkMaster("Musica e arti dello spettacolo", "I livello", "IV edizione", "musica-e-arti-dello-spettacolo-iv-edizione", "Arte, moda e spettacolo"),
  lkMaster("Nutrizione e dietetica applicata. Il Dietista di comunità", "I livello", "I edizione", "nutrizione-e-dietetica-applicata-il-dietista-di-comunita-i-edizione", "Sanità e benessere"),
  lkMaster("Progettazione nautica per il diporto di alta gamma", "I livello", "I edizione", "progettazione-nautica-per-il-diporto-di-alta-gamma-i-edizione", "Tecnologia e innovazione"),
  lkMaster("Psicologia del cambiamento", "I livello", "VI edizione", "psicologia-del-cambiamento-vi-edizione", "Sanità e benessere"),
  lkMaster("Riabilitazione della mano e dell'arto superiore", "I livello", "I edizione", "riabilitazione-della-mano-e-dellarto-superiore-i-edizione", "Sanità e benessere"),
  lkMaster("Scienza dell'alimentazione e dietetica applicata", "I livello", "I edizione", "scienza-dellalimentazione-e-dietetica-applicata-i-edizione", "Sanità e benessere"),
  lkMaster("Sicurezza urbana e gestione integrata degli eventi", "I livello", "I edizione", "sicurezza-urbana-e-gestione-integrata-degli-eventi-i-edizione", "Giuridica, PA e sicurezza"),
  lkMaster("Smart Public Administration", "I livello", "VII edizione", "smart-public-administration-vii-edizione", "Giuridica, PA e sicurezza"),
  lkMaster("Sport e disciplina osteopatica", "I livello", "I edizione", "sport-e-disciplina-osteopatica-i-edizione", "Sport"),
  lkMaster("Sport management and coaching", "I livello", "III edizione", "sport-management-and-coaching", "Sport"),

  // ---------- Link — II livello ----------
  lkMaster("Approccio Multidisciplinare ai Disturbi della Nutrizione e dell'Alimentazione e all'Obesità", "II livello", "I edizione", "approccio-multidisciplinare-ai-disturbi-della-nutrizione-e-dellalimentazione-e-allobesita-i-edizione", "Sanità e benessere"),
  lkMaster("Chirurgia plastica estetica — «Hands on»", "II livello", "I edizione", "chirurgia-plastica-estetica-hands-on-i-edizione", "Sanità e benessere"),
  lkMaster("Criminalistica", "II livello", "I edizione", "criminalistica-i-edizione", "Giuridica, PA e sicurezza"),
  lkMaster("Diplomazia, Geopolitica e relazioni internazionali", "II livello", "I edizione", "diplomazia-geopolitica-e-relazioni-internazionali-i-edizione", "Giuridica, PA e sicurezza"),
  lkMaster("Direzione e Management delle Strutture Sanitarie Complesse", "II livello", "I edizione", "direzione-e-management-delle-strutture-sanitarie-complesse-i-edizione", "Sanità e benessere"),
  lkMaster("European Master in Vascular and Endovascular Neurosurgery", "II livello", "II edizione", "european-master-in-vascular-and-endovascular-neurosurgery-ii-edizione", "Sanità e benessere"),
  lkMaster("Gestione dei Beni Culturali", "II livello", "XIII edizione", "gestione-dei-beni-culturali-xiii-edizione", "Arte, moda e spettacolo"),
  lkMaster("Management Sanitario e gestione delle risorse umane", "II livello", "I edizione", "management-sanitario-e-gestione-delle-risorse-umane-i-edizione", "Sanità e benessere"),
  lkMaster("Master Executive in Innovazione e Metodologie Avanzate per la Progettazione Europea", "II livello", "I edizione", "innovazione-e-metodologie-avanzate-per-la-progettazione-europea-i-edizione", "Economia e management"),
  lkMaster("Intelligence and Security", "II livello", "XVII edizione", "intelligence-and-security-xvii-edizione", "Giuridica, PA e sicurezza"),
  lkMaster("Intelligence Specialist", "II livello", "IX edizione", "intelligence-specialist-ix-edizione", "Giuridica, PA e sicurezza"),
  lkMaster("Medicina e chirurgia rigenerativa ad indirizzo vascolare e vulnologico", "II livello", "I edizione", "medicina-e-chirurgia-rigenerativa-ad-indirizzo-vascolare-e-vulnologico-i-edizione", "Sanità e benessere"),
  lkMaster("Medicina Estetica del Volto", "II livello", "I edizione", "medicina-estetica-del-volto-i-edizione", "Sanità e benessere"),
  lkMaster("Medicina estetica: tecnologie esclusive ed apporti innovativi", "II livello", "I edizione", "medicina-estetica-tecnologie-esclusive-ed-apporti-innovativi-i-edizione", "Sanità e benessere"),
  lkMaster("One Health: Governance delle emergenze, impatto sociale e sostenibilità sanitaria", "II livello", "I edizione", "one-health-governance-delle-emergenze-impatto-sociale-e-sostenibilita-sanitaria-i-edizione-1", "Sanità e benessere"),
  lkMaster("Ortognatodonzia", "II livello", "I edizione", "ortognatodonzia-i-edizione", "Sanità e benessere"),
  lkMaster("Master Executive in Politiche Attive, di Direzione e Gestione delle Risorse Umane", "II livello", "XII edizione", "master-executive-in-politiche-attive-di-direzione-e-gestione-delle-risorse-umane-xii-edizione", "Economia e management"),
  lkMaster("Prospettive di carriera internazionale nelle arti della musica e dello spettacolo", "II livello", "IV edizione", "prospettive-di-carriera-internazionale-nelle-arti-della-musica-e-dello-spettacolo-iv-edizione", "Arte, moda e spettacolo"),
  lkMaster("Master Executive in Sicurezza Ambientale (Geomatica per la Space Economy: costellazioni Iride e Copernicus)", "II livello", "IX edizione", "sicurezza-ambientale-geomatica-per-la-space-economy-costellazioni-iride-e-copernicus-ix-edizione", "Tecnologia e innovazione"),
  lkMaster("Tecnologie digitali e intelligenza artificiale nel flusso di lavoro odontoiatrico moderno", "II livello", "I edizione", "tecnologie-digitali-e-intelligenza-artificiale-nel-flusso-di-lavoro-odontoiatrico-moderno-i-edizione", "Sanità e benessere"),
];
